// Recording lengths are only ever shown as a rough "how much is waiting"
// figure, so anything under a minute rounds up rather than showing "0 minuten".
export const formatRecordingDuration = (durationMs?: number): string | null => {
  if (typeof durationMs !== 'number' || !Number.isFinite(durationMs) || durationMs <= 0) {
    return null;
  }

  const minutes = Math.max(1, Math.round(durationMs / 60000));
  return minutes === 1 ? '1 minuut' : `${minutes} minuten`;
};

// Live counter: minutes alone are too coarse to show that recording is
// actually progressing, so this counts seconds as mm:ss (or h:mm:ss).
export const formatElapsedClock = (durationMs: number): string => {
  const totalSeconds = Math.max(0, Math.floor(durationMs / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const pad = (value: number) => String(value).padStart(2, '0');

  return hours > 0
    ? `${hours}:${pad(minutes)}:${pad(seconds)}`
    : `${minutes}:${pad(seconds)}`;
};
